import moment from 'moment'
import {chain} from 'lodash'
import React from 'react'
import Select from 'react-select'
import Text from 'react-text'
import {Consumer} from '../../../context'
import DatePicker from '../../date-picker'
import TimePicker from '../../time-picker'
import './group-date-info.styl'

export default function GroupDateInfo (props) {
  const {validation} = props
  const addRequiredReminder = (field) => {
    return validation.missing.indexOf(field) >= 0 && (<span className="required">*</span>)
  }
  return (<Consumer>{ context => {

    const {newPlan, languageId, translate} = context
    const setNewPlan = (props) => context.setState({newPlan: {...newPlan, ...props}})

    return (
      <div className="group-date-info">
        {newPlan.id && (<React.Fragment>
        <div className="date">
          <label><Text id="date_label" /></label>
          <div className="content">
            <div className="from">
              <DatePicker
                date={moment(newPlan.start).toDate()}
                languageId={languageId}
                minDate={moment().toDate()}
                setDate={start => {
                  const finish = moment(newPlan.finish).isAfter(start)
                    ? newPlan.finish
                    : moment(start).toDate()
                  setNewPlan({start, finish})
                }}
              />
            </div>
            <div className="separator"><div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>-</div></div>
            <div className="to">
              <DatePicker
                date={moment(newPlan.finish).toDate()}
                languageId={languageId}
                minDate={moment(newPlan.start).toDate()}
                setDate={finish => {
                  setNewPlan({finish})
                }}
              />
            </div>
          </div>
        </div>
        </React.Fragment>)}
      </div>
    )}}</Consumer>)
}
